import { Box, Container, Typography } from "@mui/material";

import {
    AutoAwesomeOutlined,
    DryCleaningOutlined,
    LocalPhoneOutlined,
    LocalShippingOutlined,
} from "@mui/icons-material";

import howItWorksBg from "../../assets/images/howitwork_bg.png";
import howItWorksBgM from "../../assets/images/howitwork_bg_m.png";
import deliveryImg from "../../assets/images/step-delivery.png";
import phoneImg from "../../assets/images/step-phone.png";
import pickupImg from "../../assets/images/step-pickup.png";
import washImg from "../../assets/images/step-wash.png";

const steps = [
  {
    number: "01",
    title: "Book Service",
    desc: "Call us or schedule your pickup online in seconds.",
    icon: <LocalPhoneOutlined />,
    image: phoneImg,
  },

  {
    number: "02",
    title: "Free Pickup",
    desc: "We collect garments directly from your doorstep.",
    icon: <LocalShippingOutlined />,
    image: pickupImg,
  },

  {
    number: "03",
    title: "Expert Cleaning",
    desc: "Premium cleaning, fabric care and steam pressing.",
    icon: <DryCleaningOutlined />,
    image: washImg,
  },

  {
    number: "04",
    title: "Fresh Delivery",
    desc: "Your clothes are delivered clean, fresh and perfectly packed.",
    icon: <AutoAwesomeOutlined />,
    image: deliveryImg,
  },
];

function HowItWorks() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: {
          xs: `url(${howItWorksBgM})`,
          md: `url(${howItWorksBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        {/* Badge */}

        <Box
          sx={{
            display: "flex",

            justifyContent: "center",

            mb: 2,
          }}
        >
          <Box
            sx={{
              px: {
                xs: 2,
                md: 2.5,
              },

              py: 1,

              borderRadius: "50px",

              background: "rgba(255,255,255,.65)",

              backdropFilter: "blur(12px)",

              border: "1px solid rgba(0,87,255,.08)",

              color: "#0057ff",

              fontWeight: 700,

              textTransform: "uppercase",

              letterSpacing: "1px",

              fontSize: {
                xs: "11px",
                md: "12px",
              },
            }}
          >
            How It Works
          </Box>
        </Box>

        {/* Heading */}

        <Typography
          sx={{
            textAlign: "center",

            fontWeight: 800,

            color: "#0f172a",

            lineHeight: 1.08,

            fontSize: {
              xs: "32px",
              sm: "38px",
              md: "48px",
              lg: "54px",
            },
            maxWidth: "850px",

            mx: "auto",
          }}
        >
          Laundry Care Made
          <Box
            component="span"
            sx={{
              color: "#0057ff",
            }}
          >
            {" "}
            Simple & Hassle-Free
          </Box>
        </Typography>

        {/* Subtitle */}

        <Typography
          sx={{
            mt: 2,

            mb: {
              xs: 4,
              md: 5,
            },

            color: "#64748b",

            fontSize: {
              xs: "15px",
              md: "17px",
            },

            lineHeight: 1.8,

            maxWidth: "700px",

            mx: "auto",

            textAlign: "center",
          }}
        >
          From pickup to delivery, we handle everything with care,
          professionalism, and attention to detail.
        </Typography>

        {/* Steps */}

        {/* STEPS CARDS */}

        <Box
          sx={{
            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            alignItems: "stretch",

            gap: {
              xs: 2,
              md: 2.5,
            },

            mt: {
              xs: 4,
              md: 6,
            },

            maxWidth: "1200px",

            mx: "auto",
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                width: {
                  xs: "90%",
                  sm: "48%",
                  lg: "250px",
                },

                height: {
                  xs: 480,
                  md: 380,
                },

                background:
                  "linear-gradient(180deg, rgb(230 236 251) 0%, rgb(208 223 251) 100%)",

                backdropFilter: "blur(18px)",

                // backgroundImage: "url(${howItWorksBgM})",
                // backgroundSize: "cover",

                // backgroundPosition: "bottom",

                // backgroundRepeat: "no-repeat",

                border: "1px solid rgba(0,87,255,.12)",

                borderRadius: "28px",

                p: {
                  xs: 2.5,
                  md: 3,
                },

                position: "relative",

                overflow: "hidden",

                transition: ".35s ease",

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.12)",
                },
              }}
            >
              {/* TOP */}

              <Box
                sx={{
                  display: "flex",

                  justifyContent: "space-between",

                  alignItems: "center",

                  mb: 2,

                  position: "relative",

                  zIndex: 2,
                }}
              >
                {/* ICON */}

                <Box
                  sx={{
                    width: {
                      xs: 66,
                      md: 48,
                    },

                    height: {
                      xs: 66,
                      md: 48,
                    },

                    borderRadius: "50%",

                    background: "linear-gradient(135deg,#0057ff,#2f8cff)",

                    color: "#fff",

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    fontSize: {
                      xs: "38px",
                      md: "32px",
                    },

                    boxShadow: "0 15px 35px rgba(0,87,255,.20)",
                  }}
                >
                  {step.icon}
                </Box>

                {/* NUMBER */}

                <Box
                  sx={{
                    width: {
                      xs: 43,
                      md: 30,
                    },

                    height: {
                      xs: 46,
                      md: 33,
                    },

                    borderRadius: "8px",

                    border: "1px solid rgba(0,87,255,.15)",

                    background: "rgba(255,255,255,.9)",

                    color: "#0057ff",

                    fontWeight: 800,

                    fontSize: {
                      xs: "16px",
                      md: "12px",
                    },

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",
                  }}
                >
                  {step.number}
                </Box>
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#0f172a",
                  fontSize: {
                    xs: "20px",
                    md: "18px",
                  },

                  lineHeight: 1.15,

                  mb: 1,

                  position: "relative",

                  zIndex: 2,
                }}
              >
                {step.title}
              </Typography>

              {/* DESCRIPTION */}

              <Typography
                sx={{
                  color: "#64748b",

                  fontSize: {
                    xs: "16px",
                    md: "12px",
                  },

                  maxWidth: "95%",

                  position: "relative",

                  zIndex: 2,
                }}
              >
                {step.desc}
              </Typography>

              {/* IMAGE OVERLAY */}

              <Box
                sx={{
                  position: "absolute",

                  bottom: 0,

                  left: 0,

                  width: "100%",

                  height: { xs: "20%", md: "30%" },

                  background:
                    "linear-gradient(to top, rgba(0,87,255,.04), transparent)",

                  zIndex: 1,
                }}
              />

              {/* BOTTOM IMAGE */}

              <Box
                component="img"
                src={step.image}
                alt={step.title}
                sx={{
                  position: "absolute",

                  bottom: 0,

                  left: 0,

                  width: "100%",
                  objectFit: "contain",

                  userSelect: "none",

                  pointerEvents: "none",

                  zIndex: 1,
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default HowItWorks;
